import React from 'react'
import StudentsGeneral from '../../componentsGeneral/componentsSuperUser/StudentsOptions/StudentsGeneral'

const StudentsSU = () => {
  return (
    <>
    <StudentsGeneral />
    </>
  )
}

export default StudentsSU